import { signedOutReturnPath } from './signedOutReturn'

function isContinuation(value: string | null): value is string {
  return value !== null && /^[a-f0-9]{32}$/.test(value)
}

export function readSignOutContinuation(search: string): string | null {
  const values = new URLSearchParams(search).getAll('continuation')
  return values.length === 1 && isContinuation(values[0]) ? values[0] : null
}

export function signedOutNavigation(returnUrl: string | null, continuation: string | null, completeSignoutUrl: string): string {
  const appReturnPath = signedOutReturnPath(returnUrl)
  if (!isContinuation(continuation)) {
    return appReturnPath
  }

  const query = new URLSearchParams({ continuation, returnUrl: appReturnPath })
  return `${completeSignoutUrl}?${query.toString()}`
}
